//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "AQTooltip",
    props: {
        tooltipContent: { type: String, default: "" },
        direction: { type: String, default: "top" },
        delay: { type: Number, default: 0 },
        tooltipHeader: { type: String, default: "" }
    },
    computed: {
        anchorValues() {
            const anchorValuesObject = {
                top: "top middle",
                right: "center right",
                left: "center left",
                bottom: "bottom middle"
            };
            return anchorValuesObject[this.direction];
        },
        selfValues() {
            const selfValuesObject = {
                top: "bottom middle",
                right: "center left",
                left: "center right",
                bottom: "top middle"
            };
            return selfValuesObject[this.direction];
        },
        tooltipClasses() {
            return `${this.direction} aq-tooltip`;
        }
    }
};
